import { getSmartFetchData } from "../datasource/LicenceDataSource";

export const postCommandToController = async (controller, action, body, authStore, raiseException = false) => {
    let res;
    let url = `api/${controller}/${action}`;
    try {
        res = await getSmartFetchData(
            {
                authStore: authStore,
                url: url,
                config: {
                    method: 'POST',
                    body: body,
                },
            }
        );
        console.log(res);
    }
    catch (err) {
        if (raiseException) {
            throw err;
        }
    }
    return res;
}

export const useIsMultiTenant = async (authStore) => {
    let res = await postCommandToController('System', 'UseMultiTenant', null, authStore);
    const result = res?.data?.UseMultiTenant?.Value;
    authStore.setIsMultiTenant(result);
    return result;
}
